import React from 'react';
import { Tag } from '@bedrock/components';
import type { TagColor } from '@bedrock/components/lib/Tag';
import { REFUND_STATE_MAP, DEFAULT_REFUND_STATE_META } from '../constants';

interface RefundStatusTagProps {
  status: string;
}

/**
 * 退款单状态标签 — 对齐 MyWorkBench 充值/退款聚合列表状态渲染
 * （`MyWorkBench/utils.tsx:1753`：`<Tag color={light-${color}}>`）
 *
 * 颜色复用 REFUND_STATE_MAP.tagColor（orange/brand/green/grey，与 rechargeStateColorMap
 * 同源 bedrock TagColor 枚举），避免自定义 span 双份状态色维护。
 */
export const RefundStatusTag: React.FC<RefundStatusTagProps> = ({ status }) => {
  const meta = REFUND_STATE_MAP[status] ?? DEFAULT_REFUND_STATE_META;
  return (
    <Tag
      text={meta.label}
      size="small"
      color={`light-${meta.tagColor}` as TagColor}
    />
  );
};
